'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["options", "multiline"];
import { DropdownCheckboxItem } from "../../primitive-dropdown/dropdown-checkbox-item";
import { GenericDropdown } from "./generic-dropdown";
import { jsx as _jsx } from "react/jsx-runtime";
export function CheckboxesDropdown(_ref) {
  var checkboxes = _ref.options,
    multiline = _ref.multiline,
    props = _objectWithoutProperties(_ref, _excluded);
  var options = checkboxes.map(function (option) {
    return {
      value: option.value,
      label: option.label,
      element: function element(elementProps) {
        return /*#__PURE__*/_jsx(DropdownCheckboxItem, _objectSpread({
          checkbox: option,
          multiline: multiline
        }, elementProps));
      }
    };
  });
  return /*#__PURE__*/_jsx(GenericDropdown, _objectSpread(_objectSpread({}, props), {}, {
    multiline: multiline,
    options: options,
    multiselect: true,
    allowDeselect: true
  }));
}